export function isInView(element: Element) {
  const rect = element.getBoundingClientRect();

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.top < window.innerHeight &&
    rect.bottom >= 0
  );
}

export const IN_VIEW_ATTRIBUTE = 'data-event-in-view';

export const inViewEventAttributes = () => ({
  [IN_VIEW_ATTRIBUTE]: true,
});
